// extracted by mini-css-extract-plugin
export var blank = "animatingColumnsOrderingWithFlip-module--blank--abf4e";
export var circle = "animatingColumnsOrderingWithFlip-module--circle--c944e";
export var faiaWrap = "animatingColumnsOrderingWithFlip-module--faiaWrap--3fe86";
export var grid = "animatingColumnsOrderingWithFlip-module--grid--aaa51";
export var square = "animatingColumnsOrderingWithFlip-module--square--89467";